module.exports = __webpack_public_path__ + "static/img/BU02.9e27015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02.jpg
// module id = xVrw
// module chunks = 1